import { withDependencies, named } from '@wix/thunderbolt-ioc'
import type { FactoryWithDependencies } from '@wix/thunderbolt-ioc'
import { SiteFeatureConfigSymbol } from '@wix/thunderbolt-symbols'
import { StyleUtilsDefinition as definition } from '@wix/viewer-service-style-utils/definition'
import { StyleUtilsService as impl } from '@wix/viewer-service-style-utils/implementations'
import type { ServiceProvider } from '@wix/thunderbolt-symbols'
import type { IStyleUtilsDefinition } from '@wix/viewer-service-style-utils/definition'
import { name } from './symbols'
import type { StyleUtilsServiceSiteConfig } from './types'

export const styleUtilsService: FactoryWithDependencies<ServiceProvider<IStyleUtilsDefinition, typeof impl>> =
	withDependencies(
		[named(SiteFeatureConfigSymbol, name)],
		(siteFeatureConfig: StyleUtilsServiceSiteConfig): ServiceProvider<IStyleUtilsDefinition, typeof impl> => {
			return {
				definition,
				impl,
				config: siteFeatureConfig,
				platformConfig: siteFeatureConfig,
			}
		}
	)
